export * from '@fhs/routing/src/routes/(auth)/signin';
export { default } from '@fhs/routing/src/routes/(auth)/signin';
